<template>
	{{ config.name }}
	<div v-if="config.type == 'title'">
		<div v-for="(config, keyName) in config.content" :key="id + keyName">
			<AttrItem :config="config" :model="myModel" :myKey="keyName" :id="id" />
		</div>
	</div>
	<div v-else-if="config.type == 'select'">
		<select v-model="myModel">
			<option v-for="(option, key, index) in config.options" :value="option" :key="index">{{ key }}</option>
		</select>
	</div>
	<div v-else>
		<input :type="config.type" v-model="myModel" />
	</div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, ref } from 'vue';

export default defineComponent({
	props: ['config', 'model', 'myKey', 'id'],
	setup(props) {
		const config: any = reactive(props.config);
		const model: any = reactive(props.model);
		const myKey: any = ref(props.myKey);
		let timer: number | undefined = undefined;
		const type = config.valueType;
		const myModel: any = computed({
			get() {
				return model[myKey.value];
			},
			set(value) {
				clearInterval(timer);
				timer = setTimeout(() => {
					if (type === 'string') {
						model[myKey.value] = String(value);
						return;
					}
					if (type === 'number') {
						model[myKey.value] = Number(value);
						return;
					}
					if (type === 'boolean') {
						model[myKey.value] = Boolean(Number(value));
					}
				}, 1000);
			},
		});

		return { myModel };
	},
});
</script>

<style scoped>
div {
	display: inline-block;
}
</style>
